export const API_CONFIG = {
  baseURL:
    import.meta.env.VITE_FRAUD_BACKEND_URL || 'https://fraudapis.docteller.com',
  timeout: 30000,
  retries: 3,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
} as const;
